import SearchIcon from '@mui/icons-material/Search';
import { Box, Grid, InputBase, Stack } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ITemplateDTO } from 'wisestep-api';
import { WsButton, WsCheckboxList } from 'wisestep-base';

import WsCheckBox from '../../../../components/WsCheckBox/WsCheckBox';
import { warning } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import { INameAndId, StyledFooter } from '../../type/type';

interface ITeamsListProps {
  teamData: INameAndId[];
  onAssign(templateData: ITemplateDTO): void;
  skipHandler(): void;
  formData: ITemplateDTO;
  tabPanelPage: number;
}

const TemplateTeamsList = ({
  teamData,
  onAssign,
  skipHandler,
  formData,
  tabPanelPage,
}: ITeamsListProps) => {
  const methods = useForm();
  const { watch, setValue } = methods;
  const [filteredData, setFilteredData] = useState<INameAndId[]>(teamData);
  const [tempalateData, setTempalateData] = useState<ITemplateDTO>(formData);
  const setNotification = useNotificationStore((state) => state.setNotification);

  useEffect(() => {
    setFilteredData(teamData);
    setTempalateData(formData);
  }, [formData, teamData]);
  const selectedTeamIds = watch('teamsList');

  const teamsOptions: {
    [key: string]: string;
  } = {};

  filteredData?.forEach((team) => {
    if (team.id && team.name) {
      teamsOptions[team.id] = team.name;
    }
  });

  const handleSelectEvents = (checked: boolean) =>
    checked ? setValue('teamsList', Object.keys(teamsOptions)) : setValue('teamsList', []);

  const onTeamsInput = (event) => {
    if (!isEmpty(event.target.value)) {
      const filteredRows = filteredData?.filter((row) =>
        row?.name?.toLowerCase().includes(event.target.value.toLowerCase())
      );

      setFilteredData(filteredRows);
    } else {
      setFilteredData(teamData);
    }
  };

  const teamsIDs = () => {
    const unselectedTeams = selectedTeamIds ?? [];
    if (unselectedTeams && unselectedTeams.length > 0) {
      formData.teamIds = [...selectedTeamIds, ...(formData?.teamIds ?? [])];
      onAssign(formData);
      setValue('teamsList', []);
    } else {
      setNotification(warning('Please select minimum one team to assign to the template!'));
    }
  };

  const unAssign = () => {
    const unselectedTeams = selectedTeamIds;

    if (unselectedTeams && unselectedTeams.length > 0) {
      const filteredTeamsIds: string[] = [];
      filteredData.filter((team) => {
        if (!selectedTeamIds.includes(team.id)) filteredTeamsIds.push(team.id);
      });

      const filteredRows =
        filteredData?.filter((team) => {
          !selectedTeamIds.includes(team.id);
        }) ?? [];

      setValue('teamsList', []);
      tempalateData.teamIds = filteredTeamsIds;
      onAssign(tempalateData);
      setFilteredData(filteredRows);
    } else {
      setNotification(warning('Please select minimum one team to assign to the template!'));
    }
  };

  return (
    <Box pl={2}>
      <FormProvider {...methods}>
        <Stack direction="row" spacing={1} alignItems={'center'}>
          <SearchIcon />
          <InputBase placeholder="search" onChange={onTeamsInput} fullWidth />
        </Stack>
        <Stack spacing={1}>
          <WsCheckBox
            name="selectAll"
            label="Select All Teams"
            bold={true}
            onClick={handleSelectEvents}
          />
          <WsCheckboxList name="teamsList" options={teamsOptions} />
        </Stack>
        <StyledFooter>
          <Grid container item justifyContent="space-between" py={1}>
            <WsButton variant="text" size="large">
              {`${selectedTeamIds?.length ?? 0} Selected`}
            </WsButton>
            <WsButton onClick={skipHandler} variant="text" size="large">
              Skip
            </WsButton>
            {tabPanelPage === 0 && (
              <WsButton variant="contained" size="large" onClick={teamsIDs}>
                Assign
              </WsButton>
            )}
            {tabPanelPage === 1 && (
              <WsButton variant="contained" size="large" onClick={unAssign}>
                Unassign
              </WsButton>
            )}
          </Grid>
        </StyledFooter>
      </FormProvider>
    </Box>
  );
};

export default TemplateTeamsList;
